import { getPaddleEnvironment } from "@/lib/paddle";

export function PaymentTestModeBanner() {
  if (getPaddleEnvironment() !== "sandbox") return null;
  return (
    <div className="w-full bg-orange-100 border border-orange-300 rounded-md px-4 py-2 text-center text-sm text-orange-800">
      התשלומים בתצוגה המקדימה הם במצב בדיקה — לא יבוצע חיוב אמיתי.
    </div>
  );
}
